import styled from 'styled-components'
import { fieldLabel } from '../../styles/common'
import { softGray, menuShadow } from '../../styles/variables'

const Status = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 4px;

  ${fieldLabel}

  button {
    min-width: 124px;
    ${({ noActions }) => noActions ? `
      cursor: default;
    ` : ''}
  }

  ${({ compact }) => compact ? `
    margin-top: 0;

    button {
      margin: 2px;
      border-radius: 0;
      min-width: auto;
      padding: 8px 12px 9px;
      width: 100%;
    }
  ` : ''}
`

const Menu = styled.div`
  position: absolute;
  top: 100%;
  margin-top: 4px;
  background: white;
  padding: 8px 0;
  box-shadow: ${menuShadow};
  border-radius: 6px;
  z-index: 1;
  min-width: 160px;
`

const MenuItem = styled.div`
  padding: 8px 32px;
  cursor: pointer;
  &:hover {
    background: ${softGray};
  }
`

export default {
  Status,
  Menu,
  MenuItem,
}
